export const isEmpty = (obj: object | null | undefined): boolean => !obj || Object.keys(obj).length === 0;
